<template>
  <div class="pricing-address field">
    <div class="relative">
      <input
        id="pricing-billing-address"
        v-model="valueModel"
        v-bind="$attrs"
        @focus="focusHandle"
        @blur="blurHandle"
        type="text"
        placeholder=""
        :class="['input-field', { value: value, error: error.length > 0 }, inputClass, {'dark': isDarkFloatingLabel}]"
      >
      <label
        class="floating-label"
        :class="[labelClass, isDarkFloatingLabel ? 'dark' : '']"
        v-text="label"
      />
      <i
        v-if="error.length > 0"
        class="floating-check error-icon fas fa-exclamation-circle"
      />
      <i
        v-else-if="validate"
        class="floating-check fas fa-check-circle"
      />
    </div>
    <div
      v-show="error.length > 0"
      class="mt-1 text-xs error-message"
      v-text="error"
    />
  </div>
</template>

<script>
import { MAX_BILLING_ADDRESS_LENGTH } from '@/constants';

export default {
  props: {
    value: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
    showValidIcon: {
      type: Boolean,
      default: false,
    },
    error: {
      type: String,
      default: '',
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    inputClass: {
      type: String,
      default: '',
    },
    labelClass: {
      type: String,
      default: '',
    },
    isDarkFloatingLabel: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    focusHandle() {
      this.$emit('onFocus');
    },
    blurHandle() {
      this.$emit('onBlur');
    },
  },
  computed: {
    valueModel: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
    validate() {
      if (!this.value?.length || this.value?.length > MAX_BILLING_ADDRESS_LENGTH) {
        return false;
      }
      return this.value?.trim().length > 0;
    },
  },
};
</script>

<style scoped>
.input-field {
  @apply w-full rounded-md h-12 px-3 pr-8 outline-none bg-transparent;
  border: 1px solid #B3B3B3;
}
.input-field.dark {
  @apply text-white text-opacity-80;
}
.floating-label {
    @apply absolute pointer-events-none;
    color: #B3B3B3;
    left: 12px;
    top: calc(50% - 12px);
    transition: all 0.3s;
}

input:focus + .floating-label,
input.value + .floating-label {
  left: 0px;
  transform: scale(0.75) translateY(-32px);
  background-color: white;
  padding-left: 6px;
  padding-right: 6px;
  color: #534cda;
}
input:focus + .floating-label.dark,
input.value + .floating-label.dark {
  @apply bg-primary-purple text-white;
}
input:focus {
    border-color: #333333;
}
.floating-check {
  @apply text-primary-green absolute;
  top: calc(50% - 12px);
  right: 12px;
}
input:focus + .floating-label.invisibleLabel,
input.value + .floating-label.invisibleLabel {
  opacity: 0;
}

input.error {
  border-color: #ee5951;
}
input.error + .floating-label,
.error-icon,
.error-message {
  color: #ee5951;
}
input[readonly] {
    opacity: 0.6;
}
input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus,
input:-webkit-autofill:active  {
    -webkit-box-shadow: 0 0 0px 1000px transparent inset !important;
    box-shadow: 0 0 0px 1000px transparent inset !important;
    transition: background-color 5000s ease-in-out 0s;
    -webkit-text-fill-color: #B3B3B3 !important;
}
</style>
